var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1274,
    height: 621,
    viewBox: "0 0 1274 621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.421 137.308C961.167 175.26 1025.23 213.867 1023.86 254.334C1022.41 296.93 965.51 322.276 901.593 338.009C831.826 355.183 744.523 374.949 664.49 342.794C587.351 311.802 603.816 255.893 580.026 208.813C560.725 170.618 519.962 131.498 542.017 100.426C570.255 60.6466 621.317 18.7626 708.687 27.557C794.849 36.2298 848.595 94.2602 908.421 137.308Z",
    fill: "#20D5FC",
    fillOpacity: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.819 96.0252C467.281 78.1532 562.531 46.3552 623.177 75.0586C684.026 103.858 600.883 153.986 605.526 196.698C609.947 237.365 689.005 275.689 648.788 310.645C600.934 352.24 498.346 379.828 407.585 368.75C320.655 358.139 286.622 306.118 255.401 262.627C231.748 229.677 232.766 194.688 259.427 162.364C284.941 131.433 334.042 110.133 392.819 96.0252Z",
    fill: "#2E41EC",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_1008",
    x: 286.366,
    y: -222.905,
    width: 986.791,
    height: 832.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.64,
    result: "effect1_foregroundBlur_4_1008"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4_1008",
    x: -10.7817,
    y: -185.745,
    width: 920.219,
    height: 806.233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.64,
    result: "effect1_foregroundBlur_4_1008"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.671e9da602a4e70dacd0c920843cf541.svg";
export { ForwardRef as ReactComponent };